import { Box, Breadcrumbs, Button, FormControl, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Toolbar, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import MainHeader from "../components/MainHeader";
import Main from "../components/Main";
import { Link } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ReferralsTable from "../components/tables/ReferralsTable";
import SearchIcon from '@mui/icons-material/Search';
import SideMenu from "../components/SideMenu";
import AppNavBar from "../components/AppNavBar";
import AppBottomNavigation from "../components/AppBottomNavigation";
import ReferralFormDialog from "../components/dialogs/ReferralFormDialog";
import { deleteReferral, exportReferrals, fetchReferrals } from "../services/ReferralsService";
import { AuthContext } from "../utils/AuthContext";

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import AlertDialog from "../components/AlertDialog";
import moment from "moment";
import getHomeLink from "../utils/getHomeLink";
import CheckIcon from '@mui/icons-material/Check';


const Referrals = () => {
    const [open, setOpen] = useState(localStorage.getItem('drawer-open') == 'true');

    const [searchReferral, setSearchReferral] = useState()
    const [filterBy, setFilterBy] = useState('client_name')

    const [openAddReferralDialog, setOpenAddReferralDialog] = useState(false);
    const [referralToDelete, setReferralToDelete] = useState();

    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { auth } = useContext(AuthContext);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const [isExporting, setIsExporting] = useState(false);


    useEffect(() => {
        handleFetchReferrals();
    }, []);

    // useEffect(() => {
    //     handleFetchReferrals();
    // }, [page, rowsPerPage]);

    useEffect(() => {
        if (searchReferral === undefined) {
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            handleFetchReferrals();
        }, 1500)

        return () => clearTimeout(delayDebounceFn)
    }, [searchReferral])

    useEffect(() => {
        if (referralToDelete == null) {
            return;
        }

        setOpenDeleteDialog(true);
    }, [referralToDelete]);


    useEffect(() => {
        if (!openDeleteDialog) {
            setReferralToDelete(null);
        }
    }, [openDeleteDialog]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        handleFetchReferrals({ _page: newPage });
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);

        handleFetchReferrals({ _rows_per_page: event.target.value });
    };

    const toggleDrawer = () => {
        localStorage.setItem('drawer-open', !open);
        setOpen(!open);
    };

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    async function handleFetchReferrals(data) {
        setIsLoading(true);
        fetchReferrals({
            filterBy: data?._filter_by || filterBy,
            token: auth.token,
            searchQuery: data?._search_query || searchReferral,
            page: (data?._page || page) + 1,
            pageSize: data?._rows_per_page || rowsPerPage
        }).then(res => {
            setRows(res.data.referrals);
            setTotalRecords(res.data.total);
            setIsLoading(false);
        }).catch(error => {
            console.error("Error fetching clients:", error);
            setIsLoading(false);
        });
    }

    const breadcrumbs = [
        <Link sx={{ textDecoration: 0 }} key="1" color="inherit" to={getHomeLink(auth)}>
            Home
        </Link>,
        // <Link
        //     underline="hover"
        //     key="2"
        //     color="inherit"
        //     href="/material-ui/getting-started/installation/"
        //     onClick={handleClick}
        // >
        //     Core
        // </Link>,
        <Typography key="2" sx={{ color: 'text.primary' }}>
            Referrals
        </Typography>,
    ];

    const handleClickAdd = () => {
        setOpenAddReferralDialog(true);
    };

    async function handleDeleteReferral() {
        try {
            await deleteReferral({ token: auth.token, referralId: referralToDelete.id });

            handleFetchReferrals();

            toast.success("Referral Deleted", {
                autoClose: 2000,
                hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });
        } catch (err) {
            toast.error(err.response.data.message, {
                autoClose: 3000,
                hideProgressBar: true,
            });
        }
    }


    const handleExportReferrals = async () => {

        try {
            const token = auth.token;
            const filters = {
                filterBy,
                searchQuery: searchReferral,
            };

            setIsExporting(true)
            // Show loading toast without auto-closing
            const loadingToastId = toast.info("Exporting referrals...", { autoClose: false });
            const blob = await exportReferrals({ token, filters });
            setIsExporting(false)

            // Close loading toast
            toast.dismiss(loadingToastId);

            // Show success toast with 2-second duration
            toast.success("Referrals exported", {
                autoClose: 2500, hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });


            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "Referrals_Export_" + moment().format('YYYY_MM_DD') + ".csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            // Handle error
            console.error('Error exporting referrals:', error);
        }
    };

    return (
        <Box sx={{
            backgroundColor: '#ededed',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Ensure no vertical scrollbar
        }}>
            <AppNavBar currentPage='referrals' />
            <ToastContainer />

            <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>

                <SideMenu currentPage='referrals' />

                <Main
                    open={open}
                    sx={{
                        // height: '100%',
                        overflow: 'hidden',
                        marginLeft: {
                            xs: 0,
                            md: 1
                        },
                        backgroundColor: '#fff',
                        mt: 7,
                        mb: 2,
                        marginRight: {
                            xs: 0,
                            md: 1
                        },
                        borderRadius: {
                            xs: 0,
                            md: 2
                        },
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        px: {
                            xs: 2,
                            md: 3
                        },
                        py: 2
                    }} >

                    <Box sx={{
                        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: {
                            xs: 2,
                            md: 1
                        }, alignItems: 'start'
                    }}>
                        <Box>
                            <Typography variant="h1" sx={{ fontSize: 24 }}>
                                Referrals
                            </Typography>

                            <Stack sx={{
                                display: {
                                    xs: 'none',
                                    md: 'block'
                                },
                                mt: 1
                            }} spacing={2}>
                                <Breadcrumbs
                                    separator={<NavigateNextIcon fontSize="small" />}
                                    aria-label="breadcrumb"
                                >
                                    {breadcrumbs}
                                </Breadcrumbs>
                            </Stack>
                        </Box>

                        {
                            auth.user.user_type === 'Agent' && (
                                <Box>
                                    <Button onClick={handleClickAdd} variant="contained" sx={{ ml: 1 }}>
                                        Add Referral
                                    </Button>
                                </Box>
                            )
                        }

                    </Box>

                    <Box sx={{
                        width: '100%', mb: '15px', display: 'flex', flexDirection: 'row', justifyContent: {
                            xs: 'left',
                            md: 'right'
                        }, gap: 2
                    }}>


                        <TextField className="search" sx={{ mt: 1, ml: 1 }} size='small' variant='standard' placeholder="Search..." InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                            value={searchReferral}
                            onChange={(e) => {
                                setSearchReferral(e.target.value)
                            }}
                        />
                        <Box>
                            <FormControl size="small" variant="outlined">
                                <InputLabel id="filter-by-select-label">Filter By</InputLabel>
                                <Select
                                    labelId="filter-by-select-label"
                                    id="filter-by-select"
                                    label="Filter By"
                                    value={filterBy}
                                    onChange={(e) => {
                                        setFilterBy(e.target.value)
                                        handleFetchReferrals({ _filter_by: e.target.value });
                                    }}

                                >
                                    <MenuItem value={'client_name'}>Client Name</MenuItem>
                                    <MenuItem value={'nationality'}>Nationality</MenuItem>
                                    <MenuItem value={'residence'}>Residence</MenuItem>
                                    <MenuItem value={'email_address'}>Email Address</MenuItem>
                                    <MenuItem value={'status'}>Status</MenuItem>
                                    {
                                        auth.user.user_type === 'Admin' &&
                                            <MenuItem value={'agent_id'}>Agent ID</MenuItem>
                                    }
                                    {
                                        auth.user.user_type === 'Admin' &&
                                            <MenuItem value={'agent_name'}>Agent Name</MenuItem>
                                    }

                                </Select>
                            </FormControl>
                        </Box>
                        <Button sx={{
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}
                            variant="contained"
                            disabled={isExporting}
                            onClick={handleExportReferrals}>Export</Button>
                    </Box>


                    <ReferralsTable
                        referrals={rows}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        totalRecords={totalRecords}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        isLoading={isLoading}
                        handleFetchReferrals={handleFetchReferrals}
                        setReferralToDelete={setReferralToDelete}
                    />

                    {/* Bottom Navigation */}
                    <Paper sx={{
                        zIndex: 9997,
                        display: {
                            xs: 'block',
                            md: 'none'
                        }, position: 'fixed', bottom: 0, left: 0, right: 0
                    }} elevation={3}>
                        <AppBottomNavigation currentPage="referrals" />
                    </Paper>

                    <ReferralFormDialog
                        dialogOpen={openAddReferralDialog}
                        setDialogOpen={setOpenAddReferralDialog}
                        callback={handleFetchReferrals}
                        mode="create"
                    />

                </Main >
            </Box>

            {
                referralToDelete != null &&
                <AlertDialog
                    title='Delete Referral'
                    content={'Do you want to delete referral?'}
                    open={openDeleteDialog}
                    setOpen={setOpenDeleteDialog}
                    positiveButtonLabel='Yes'
                    negativeButtonLabel='Cancel'
                    callback={() => {
                        handleDeleteReferral();
                        setOpenDeleteDialog(false);
                    }} />
            }
        </Box>
    );
};

export default Referrals;